import { Product } from "schema-dts";

import { MenuItem } from "@/custom-types/MenuItem";

export default (product: MenuItem, countryCode: string): Product => {
  return {
    "@type": "Product",
    name: product.name,
    ...(product.brandName && {
      brand: { "@type": "Brand", name: product.brandName },
    }),
    ...(product.description && { description: product.description }),
    ...(product.imageUrl && { image: product.imageUrl }),
    ...(product.thcContentLabel && {
      additionalProperty: [
        {
          "@type": "PropertyValue",
          name: "THC Content",
          value: product.thcContentLabel,
        },
      ],
    }),
    ...(product.price && {
      offers: {
        "@type": "Offer",
        availability: "https://schema.org/InStock",
        price: product.price,
        priceCurrency: countryCode === "US" ? "USD" : "CAD",
      },
    }),
  };
};
